import React from "react";
import SidebarTitle from "./SidebarTitle";
import SidebarContainer from "./SidebarContainer";
import SidebarContent from "./SidebarContent";
import SidebarFooter from "./SidebarFooter";

const Sidebar = props => {
  const { sceneSetting, onStepChange, children, currentSubStepName, zoom } = props;
  const { levelsSetting, currentStep, currentSubStep } = sceneSetting;
  const totalSteps = levelsSetting.length
    ? levelsSetting[currentStep].configuration.length
    : 0;
  let classes = "sidebar"
  if (zoom) classes += " closed"
  return (
    <div className={classes}>
      <SidebarTitle
        title={currentSubStepName}
        totalSteps={totalSteps}
        currentSubStep={currentSubStep + 1}
      />
      <SidebarContainer>
        <SidebarContent>{children}</SidebarContent>
        <SidebarFooter sceneSetting={sceneSetting} currentSubStepName={currentSubStepName} onStepChange={type => onStepChange(type)} />
      </SidebarContainer>
    </div>
  );
};

export default Sidebar;
